import React from "react";
import { useAuthContext } from "@src/context/authContext";
import { useDCContext } from "@src/context";
import ManagerHooks from "@src/context/hooks/managerHooks";
import { BehiveLayout } from "@src/components/layout";
import { Loader } from "@src/components/atoms";
import { SignolUtils } from "@src/utils";

const BehiveTab = (props) => {
  const { behiveLayoutDCString, behaviourCardClickThroughHandler } = props;
  const dc = useDCContext();
  const auth = useAuthContext();
  const layoutDC = dc.getDynamicReplacement(behiveLayoutDCString);
  const layout = JSON.parse(layoutDC.props.children);
  const layoutJSONs = SignolUtils.getBehiveLayoutJSONs(layout);

  const {
    data: plotlyData,
    isPending: isPendingPlotlyData,
    error: errorPlotlyBVRData,
  } = ManagerHooks.useGetPlotlyBVRGraphs(layoutJSONs, auth.activeRole);

  if (isPendingPlotlyData) return <Loader />;

  if (errorPlotlyBVRData || !plotlyData?.graphs?.length) {
    return <div className="text-gray-500 p-8">Missing analysis data.</div>;
  }

  return (
    <BehiveLayout
      layout={layout}
      data={plotlyData}
      behaviourCardClickThroughHandler={behaviourCardClickThroughHandler}
    />
  );
};
export default BehiveTab;
